export default "__VITE_ASSET__D2oYQwna__"